<template>
    <div class="price-range">
        <div class="price-range-title">Цены:</div>
        <div class="price-range-selector">
            <div class="price-range-selector__from"></div>
            <div class="price-range-selector__diapason"></div>
            <div class="price-range-selector__to"></div>
        </div>
        <div class="price-range-inputs">
            <div class="price-range-from">
                <price-input :price="min_price"></price-input>
            </div>
            <span> - </span>
            <div class="price-range-to">
                <price-input :price="max_price"></price-input>
            </div>
        </div>
    </div>
</template>

<script>
    import PriceInput from '../Inputs/PriceInput';
    export default {
        name: "PriceRange",
        components: { PriceInput },
        data() {
            return {
                min_price: 4000,
                max_price: 70000
            }
        }
    };
</script>

<style scoped lang="scss">
    .price-range {
        &-selector {
            background: #D8DDE4;
            border-radius: 9px;
            height: 6px;
            margin: 23px 0 27px;
            width: 100%;
            position: relative;
            > div:not(.price-range-selector__diapason) {
                background: #fff;
                border: 4px solid #3FB0AB;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                position: absolute;
                top: -8px;
                z-index: 10;
            }
            &__from {
                left: 50px;
            }
            &__to {
                right: 50px;
            }
            &__diapason {
                background: #3FB0AB;
                border: none;
                width: calc(100% - 100px);
                height: 6px;
                position: absolute;
                left: 50px;
            }
        }
        &-inputs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            > div {
                max-width: 128px;
            }
        }
    }
</style>
